<template>
	<div class="image-input">
		<label>{{ label }}</label>
		<lazy-image :src="src" v-if="image && typeof(image) !== 'object'"></lazy-image>
		<img :src="src" v-if="image && typeof(image) === 'object'" />
		<div class="actions">
			<button @click.prevent="chooseImage">Upload</button>
			<transition name="fade" mode="out-in">
				<button @click.prevent="image = null" v-if="image">Remove</button>
			</transition>
		</div>
		<input type="file" style="display: none;" ref="file" @change="updateSrc" accept=".png,.gif,.jpeg,.jpg" />
	</div>
</template>

<script>
	export default {
		props: ['value', 'disabled', 'label'],
		data() {
			return {
				image: this.value
			};
		},
		computed: {
			src() {
				if(!this.image) {
					return null;
				}
				if(typeof(this.image) === 'string') {
					return this.image;
				}
				if(typeof(this.image) === 'object') {
					return URL.createObjectURL(this.image);
				}
			}
		},
		watch: {
			value() {
				this.image = this.value;
			},
			image() {
				this.$emit('input', this.image);
			}
		},
		methods: {
			chooseImage() {
				if(this.disabled){
					return;
				}
				this.$refs.file.dispatchEvent(new MouseEvent('click'));
			},
			updateSrc(event) {
				if(this.disabled){
					return;
				}
				this.image = event.currentTarget.files[0];
				event.currentTarget.value = '';
			}
		}
	}
</script>